import { put, call } from 'redux-saga/effects';
import { translations } from '../translations';
import * as alert from '../store/alert/alertActions';
import { errorHandler } from './errorHandler';

const getCurrentLanguage = () => {
  return localStorage.getItem('language') || 'tr';
};

const t = (key) => {
  const language = getCurrentLanguage();
  return translations[language]?.[key] || translations['tr'][key] || key;
};

export function* handleSagaError(error, action, errorAction) {
  if (error.isSessionExpired) {
    console.log('Session expired detected in saga');
    
    yield put(
      alert.setAlertAction({
        title: t('sessionTimeoutTitle'),
        text: error.message || t('sessionExpired'),
        variant: 'warning',
        outTimeMS: 3000,
      }),
    );
    
    yield put(errorAction({
      message: error.message || t('sessionExpired'),
      code: 'SESSION_EXPIRED'
    }));
    
    return true;
  }

  if (error.response) {
    console.error('HTTP Error Response:');
    console.error('Status:', error.response.status);
    console.error('Status Text:', error.response.statusText);
    console.error('Response Data:', error.response.data);
    
    let errorTitle = t('httpError');
    let errorMessage = t('requestFailedError');
    
    switch (error.response.status) {
      case 400:
        errorMessage = t('badRequestError');
        break;
      case 401:
        errorMessage = t('unauthorizedError');
        break;
      case 403:
        errorMessage = t('accessDeniedError');
        break;
      case 404:
        errorMessage = t('notFoundError');
        break;
      case 500:
        errorMessage = t('internalServerError');
        break;
      case 503:
        errorMessage = t('serviceUnavailableError');
        break;
      default:
        const apiErrorMessage = error.response.data?.Result?.ErrorDescription;
        errorMessage = apiErrorMessage || 
        `HTTP ${error.response.status}: ${error.response.statusText}`;
    }
    
    yield put(
      alert.setAlertAction({
        title: errorTitle,
        text: errorMessage,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    
    yield put(errorAction({
      response: error.response,
      code: error.response.status,
      message: errorMessage
    }));
    
  } else if (error.request) {
    console.error('Network Error - Request made but no response:');
    console.error('Request:', error.request);
    
    yield put(
      alert.setAlertAction({
        title: t('networkError'),
        text: t('connectionErrorMessage'),
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    
    yield put(errorAction({
      message: t('connectionErrorMessage'),
      code: 'NETWORK_ERROR'
    }));
    
  } else {
    console.error('General Error:', error.message);
    
    if (error.message === 'Network Error') {
      console.log('Network Error detected - possible session timeout');
      
      localStorage.removeItem('user');
      localStorage.removeItem('sessionUserId');
      localStorage.removeItem('token');
      localStorage.removeItem('authToken');
      
      yield put(
        alert.setAlertAction({
          title: t('sessionTimeoutTitle'),
          text: t('sessionTimeoutMessage'),
          variant: 'warning',
          outTimeMS: 3000,
        }),
      );
      
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
      
      yield put(errorAction({
        message: t('sessionExpired'),
        code: 'SESSION_EXPIRED'
      }));
      
      return true;
    }
    
    yield put(
      alert.setAlertAction({
        title: t('unexpectedError'),
        text: error.message || t('unexpectedErrorMessage'),
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    
    yield put(errorAction({
      message: error.message || t('unexpectedErrorMessage'),
      code: 'UNKNOWN_ERROR'
    }));
  }
  
  yield call(errorHandler, error, action.history, action.href);
  
  return false;
}
